import { ComponentType } from 'react';
import ProcessIndicator from './ProcessIndicator';
import Item, { Props as ItemComponentProps } from './ProcessIndicatorItem';

// to add property to a function in typescript
// tslint:disable-next-line prefer-object-spread
export default Object.assign(ProcessIndicator, {
  Item: Item as ComponentType<ItemComponentProps>,
});
